export class PayloadTooLarge extends Error {
  constructor() {
    super()
    this.name = this.constructor.name
  }
}
